import React, { useState } from "react";
import Rightaside from "../reusable/Rightaside";
import {
  ABOUT_CARDS,
  ASIDE_HOME_HERO,
  HOME_CARDS,
  HOME_DEMO_CARDS,
  WHY_CHOOSE_US,
} from "../utils/constants";
import Cards from "../reusable/Cards";
import HomeDemo from "../reusable/HomeDemo";
import { IMAGES } from "../utils/images";
import "../Styles/home.css";
import AboutCard from "../reusable/AboutCard";
import { Link } from "react-router-dom";
import StartAnewCareer from "./StartAnewCareer";
import ReviewSection from "../reusable/ReviewSection";

const Home = () => {
  return (
    <div className="outlet-render-home">
      <Link to="/enroll-now" className="banner-link">
        <img src={IMAGES.HERO_MAIN_BAR} alt="Main Bar" className="main-bar" />
      </Link>

      <Rightaside {...ASIDE_HOME_HERO} />
      <div className="what-we-offers">
        <div className="what-we-offers-header">
          <h1 className="what-we-offers-heading">What we offers?</h1>
          <p className="what-we-offers-body">
            Comprehensive Training Solutions Tailored to Your Learning Style.
          </p>
        </div>
        <div className="about-card-container">
          {ABOUT_CARDS.map((item, index) => {
            return <AboutCard {...item} key={index} />;
          })}
        </div>
      </div>
      <StartAnewCareer />
      <ReviewSection />
      <div className="upcoming-batches">
        <h2 className="upcoming-batches-heading">Upcoming Batches</h2>
        <div className="home-cards">
          {HOME_CARDS.map((item, index) => {
            return <Cards {...item} key={index} />;
          })}
        </div>
      </div>
      <div className="free-demo-section">
        <div className="free-demo-top">
          <h3 className="free-demo-title">Not Sure for the Above Program?</h3>
          <h2 className="free-demo-body">
            Try a Free Demo of Techstack Courses
          </h2>
          <button className="free-demo-btn">Apply for Free Demo</button>
        </div>
        <div className="home-cards">
          {HOME_DEMO_CARDS.map((item, index) => {
            return <HomeDemo {...item} key={index} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Home;
